class Validation {
    constructor(resultFunc) {
        this.resultFunc = resultFunc;
    }
}

export default Validation;
